import React from 'react'
import {NullAsDefault} from 'views/Shared'
import Translate from "../../../../modules/local/Translate";
import {renderIf} from "../../../Shared";
import getTitle from "../../../../helpers/getTitle";
import {ItemInformation} from "../../Organization/OrganizationEntity";
import {DatePlaceItem} from "../components/CatholicHouseholdComponents";
import {GoDotFill} from "react-icons/go";
import {Avatar} from "antd";
import {RiUser2Fill} from "react-icons/ri";
import {formatDate} from "../../../../helpers/datetimeHelpers";


export const renderCatholicHouseholdMemberWithSacrament = ({ renderContextMenu = NullAsDefault, handleAction = NullAsDefault} = {}, sacrament_type ) => (item, index) => {

    const {member_user, patron_saint_name, name, sacraments = [],} = item ?? {}

    const SacramentInfo = ({type}) => (
        <Translate>
            {(t) => (
                sacraments.map((e, i) => {
                    const {eff_date, church_name, officiant_name, participant_name, sacrament_type} = e ?? {}
                    return (
                        renderIf(
                            type === sacrament_type,
                            <div key={i} style={{ marginLeft: 10 }} className="flex flex-col gap-1">
                                <DatePlaceItem
                                    showIcon={true}
                                    label={type === 'matrimony' ? t('date of celebration') : `${t('date')} ${t(type)}`}
                                    date={formatDate(eff_date, 'DD/MM/YYYY')}
                                    place={church_name}
                                    className="text-xs"
                                />
                                {renderIf(
                                    officiant_name,
                                    <div className="space-x-1 text-xs">
                                        <GoDotFill size={10} className="text-color-400" />
                                        <span className="text-color-500 italic whitespace-no-wrap">
                                            {`${t('by_prelate')} : `}
                                        </span>
                                        <span className="font-semibold text-color-100">
                                            {officiant_name}
                                        </span>
                                        <span className="text-color-500 italic whitespace-no-wrap">
                                            {`${t("celebrate")}.`}
                                        </span>
                                    </div>
                                )}
                                {renderIf(
                                    participant_name,
                                    <ItemInformation
                                        showIcon={true}
                                        label={type === 'matrimony' ? 'marriage witnesses' : 'godparent'}
                                        value={participant_name}
                                        className="text-xs"
                                    />
                                )}
                            </div>
                        )
                    )
                })
            )}
        </Translate>
    )

    return (
        <div key={index} className="py-2 flex flex-col gap-1 rounded-lg custom-item-render custom-render-border relative">
            <div className="flex items-center gap-x-2">
                <Avatar
                    size={30}
                    src={member_user?.avatar}
                    icon={<RiUser2Fill size={16} className="text-color-500"/>}
                    className="flex flex-center background-200"
                />
                <div
                    onClick={() => {handleAction('CATHOLIC_HOUSEHOLD_MEMBER_VIEW', item)}}
                    className="flex-1 space-x-1 text-color-000 hover:text-primary cursor-pointer max-lines-1 mr-6">
                    <span className="font-medium text-sm text-color-100 italic">
                        {patron_saint_name}
                    </span>
                    <span className="font-bold">
                        {name ? name : getTitle(member_user)}
                    </span>
                </div>
            </div>

            <SacramentInfo type={sacrament_type} />
            <div className="absolute right-5 top-5 contextIcon">
                {renderContextMenu(item)}
            </div>
        </div>
    )
}



